import {faShieldHalved} from '@fortawesome/pro-solid-svg-icons';

import {PageLayout} from '../../_old/PageLayout/PageLayout';
import {Heading} from '../Heading';
import {Text} from '../Text';

import {ErrorScreenContainer, ErrorScreenIcon} from './common';

export function ForbiddenErrorScreen(): React.JSX.Element {
  return (
    <PageLayout.Main>
      <PageLayout.Content>
        <ErrorScreenContainer>
          <ErrorScreenIcon icon={faShieldHalved} className="text-amber9" />

          <div className="text-center text-slate12">
            <Heading tag="h1" as="title">
              Unauthorized
            </Heading>
            <Text>You do not have permission to view this page.</Text>
            <Text>Please contact your administrator for more information.</Text>
          </div>
        </ErrorScreenContainer>
      </PageLayout.Content>
    </PageLayout.Main>
  );
}
